import { z } from 'zod';

import type { Media } from '@/submodules/generated_types/types/media';

const UserSchema = z.object({
  id: z.coerce.number(),
  firstName: z.string(),
  lastName: z.string(),
  profileImage: z.custom<Media>().nullable(),
});

export const MessageSchema = z.object({
  id: z.coerce.number(),
  senderId: z.coerce.number(),
  sender: UserSchema,
  body: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  attachments: z.array(
    z.object({
      id: z.coerce.number(),
      media: z.custom<Media>(),
    })
  ),
  states: z.array(
    z.object({
      userId: z.coerce.number(),
      isRead: z.coerce.boolean(),
    })
  ),
});
export type Message = z.infer<typeof MessageSchema>;

export const ThreadStatus = {
  ALL: 'all',
  UNREAD: 'unread',
  IMPORTANT: 'important',
  SENT: 'sent',
  STARRED: 'starred',
} as const;
export type ThreadStatus = (typeof ThreadStatus)[keyof typeof ThreadStatus];
export const conversationSchema = z.object({
  id: z.coerce.number(),
  subject: z.string(),
  isImportant: z.coerce.boolean(),
  course: z.object({
    id: z.coerce.number(),
    name: z.string(),
    endDate: z.coerce.date().nullable(),
    instructors: z.array(z.object({
      instructorId: z.number()
    })),
    enrollees:z.array(z.object({
      enrolleeId:z.number()
    })),
  }),
  createdBy: UserSchema,
  userConversationStates: z.array(
    z.object({
      userId: z.coerce.number(),
      isRead: z.coerce.boolean(),
      isStarred: z.coerce.boolean(),
    })
  ),
  recipients: z.array(
    z.object({
      id: z.coerce.number(),
      user: UserSchema,
    })
  ),
  messages: z.array(MessageSchema),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Thread = z.infer<typeof conversationSchema>;

export const CreateMessageSchema = z.object({
  body: z.string(),
  attachmentMediaIds: z.array(z.coerce.number().int()).optional(),
});

export type CreateMessageType = z.infer<typeof CreateMessageSchema>;

export const CreateConversationSchema = CreateMessageSchema.extend({
  courseId: z.coerce.number().int(),
  recipientIds: z.array(z.coerce.number().int()).min(1),
  subject: z.string().max(256),
  isImportant: z.coerce.boolean(),
});

export type CreateConversationType = z.infer<typeof CreateConversationSchema>;
